export const skills = [
    {
        "level": "",
        "keywords": [
            {
                "name": "Python",
                "level": 80
            },
            {
                "name": "Javascript",
                "level": 65
            },
            {
                "name": "Java",
                "level": 40
            },
            {
                "name": "Scala",
                "level": 30
            }
        ],
        "name": "Programming Languages"
    },
    {
        "keywords": [
            {
                "name": "MongoDB",
                "level": 75
            },
            {
                "name": "MySQL",
                "level": 75
            },
            {
                "name": "Apache Cassandra",
                "level": 60
            },
            {
                "name": "HBase",
                "level": 20
            },
            {
                "name": "Elasticsearch",
                "level": 70
            }
        ],
        "name": "Databases"
    },
    {
        "keywords": [
            {
                "name": "Django REST",
                "level": 70
            },
            {
                "name": "React",
                "level": 65
            },
            {
                "name": "Spring Boot",
                "level": 55
            },
        ],
        "name": "Framework & Library"
    },
    {
        "keywords": [
            {
                "name": "Apache Kafka",
                "level": 70
            },
            {
                "name": "Apache Spark",
                "level": 55
            },
            {
                "name": "RabbitMQ",
                "level": 60
            },
        ],
        "name": "Streaming Technologies"
    },
    {
        "keywords": [
            {
                "name": "GIT",
                "level": 90
            },
            {
                "name": "Docker",
                "level": 75
            },
        ],
        "name": "DevOps Tools"
    },
    {
        "keywords": [
            {
                "name": "TDD",
                "level": null
            },
            {
                "name": "Microservices",
                "level": null
            },
        ],
        "name": "Others"
    }
]